export default function sleep(ms: number): Promise<any> {
  return new Promise((resolve) => window.setTimeout(resolve, ms));
}
